/**
 * Fields — and the labels above them — render at 16px on a phone.
 *
 * iOS Safari zooms the page in whenever a field smaller than 16px takes focus,
 * and it never zooms back out: the reader is left on a page wider than the
 * screen with the keyboard up. 16px is the threshold, so this is the whole fix.
 * The labels follow the fields up rather than staying at 14px, so a form does
 * not read as two type sizes stacked on each other.
 *
 * Spread on the surface rather than set per field: one field left behind is one
 * field that zooms, and the surfaces below hold forms built from several
 * components. It carries its own media query so it is equally safe on a modal
 * that is also opened from a desktop, where no such rule applies.
 *
 * Matches `(max-width: 768px)`, the width at which the app swaps to its mobile
 * layouts.
 */
export const MOBILE_FORM_FONT_SX = {
  '@media (max-width: 768px)': {
    'input, textarea, select, [contenteditable="true"], label': { fontSize: '16px' }
  }
} as const
